import { Select } from 'antd';
import React from 'react';

const SelectDoc = (props) => {
  const { onChange, defaultValue } = props;
  const documents = [
    { label: "  Bon de Pharmacie", value: "BPI" },
    { label: "Lettre de garantie", value: "LGI" },
    { label: "LG Hospitalisation", value: "LHI" },
    { label: "Bon Optique", value: "BCI" },
    { label: "Ticket Remboursement", value: "TIC" },
    { label: "Tous les documents", value: "AAA" },

  ];
 
  return (
    <div>
      <Select
      bordered={false} 
        style={{ width:"200px",  borderBottom: '2px solid #030303'}}
        options={documents}
        showSearch
        onChange={onChange} // Correction : onChange au lieu de onchange
        defaultValue={defaultValue}
      />
    </div>
  );
};

export default SelectDoc;
